function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3825 22.42C14.4066 20.2273 12.6852 18.4225 10.5938 17.3992M15.3825 22.42C18.6355 19.0094 23.7123 13.6867 23.7123 13.6867C25.6234 11.6829 26.7719 9.01717 26.9425 6.1891L27 5.23633L26.0754 5.29427C23.3784 5.4633 20.834 6.66281 18.9235 8.66587C18.9235 8.66587 13.8468 13.9886 10.5938 17.3992M15.3825 22.42C17.4227 20.281 20.6066 16.9427 20.6066 16.9427C22.3698 18.7913 22.3698 21.7885 20.6066 23.6371L17.4141 26.9843C17.4141 26.9843 16.1759 24.2025 15.3825 22.42ZM10.5938 17.3992C12.634 15.2602 15.8179 11.922 15.8179 11.922C14.0547 10.0734 11.1961 10.0734 9.43292 11.922L6.24043 15.2692C6.24043 15.2692 8.89372 16.5674 10.5938 17.3992ZM10.6948 25.6612C9.7614 26.6399 6 27.2363 6 27.2363C6 27.2363 6.56891 23.2927 7.50235 22.314C8.43579 21.3353 9.90715 21.2912 10.7887 22.2155C11.6703 23.1398 11.6283 24.6825 10.6948 25.6612Z",
  stroke: "currentColor"
});

function SvgRocketLaunch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket-launch.ef39dc7e.svg";
export { ForwardRef as ReactComponent };